// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blog__grid[data-v-2ff06642]{grid-gap:1.75rem;gap:1.75rem;display:grid;grid-template-columns:1fr}@media (min-width:544px){.blog__grid[data-v-2ff06642]{grid-template-columns:repeat(2,1fr)}}@media (min-width:992px){.blog__grid[data-v-2ff06642]{grid-template-columns:repeat(3,1fr)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
